export default __webpack_public_path__ + "static/media/REJECT.75268dd9.png";